export const DEFINE_PROFILE = 'DEFINE_PROFILE';
export const CLEAR_PROFILE = 'CLEAR_PROFILE';

export const DEFINE_PROFILE_SOCIAL = 'DEFINE_PROFILE_SOCIAL';
export const DEFINE_PROFILE_ADDRESS = 'DEFINE_PROFILE_ADDRESS';
export const DEFINE_PROFILE_CONTACT = 'DEFINE_PROFILE_CONTACT';
export const DEFINE_PROFILE_EMPLOYMENT = 'DEFINE_PROFILE_EMPLOYMENT';
export const DEFINE_PROFILE_DECLARATIONS = 'DEFINE_PROFILE_DECLARATIONS';
export const DEFINE_PROFILE_DEMOGRAPHICS = 'DEFINE_PROFILE_DEMOGRAPHICS';
export const DEFINE_PROFILE_REAL_ESTATE_EXPERIENCE =
  'DEFINE_PROFILE_REAL_ESTATE_EXPERIENCE';
export const DEFINE_PROFILE_REAL_ESTATE_OPERATION =
  'DEFINE_PROFILE_REAL_ESTATE_OPERATION';
export const DEFINE_PROFILE_APPLICATION = 'DEFINE_PROFILE_APPLICATION';
export const DEFINE_PROFILE_AGREEMENT = 'DEFINE_PROFILE_AGREEMENT';

export const UPDATE_INCOME = 'UPDATE_INCOME';
export const UPDATE_ASSETS = 'UPDATE_ASSETS';
export const UPDATE_LIABILITIES = 'UPDATE_LIABILITIES';
export const UPDATE_FINANCES = 'UPDATE_FINANCES';



// WEBPACK FOOTER //
// ./src/vuex/modules/profile/types/actions.js